var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94453 14.8751H7.38203C7.34453 14.8688 7.31328 14.8563 7.27578 14.8563C6.57578 14.8063 5.90703 14.6188 5.30078 14.2688C3.92578 13.4876 3.07578 12.3188 2.80703 10.7501C2.58828 9.48135 2.83828 8.3001 3.55703 7.23135C4.89453 5.23135 6.24453 3.2376 7.58828 1.24385C7.61328 1.20635 7.63203 1.16885 7.65078 1.13135C7.65703 1.13135 7.66953 1.13135 7.67578 1.13135C7.69453 1.16885 7.71328 1.2126 7.73828 1.24385C8.31953 2.1126 8.90703 2.98135 9.49453 3.84385C9.55703 3.93135 9.55078 3.9876 9.49453 4.0751C9.07578 4.6876 8.65703 5.3001 8.25078 5.91885C7.70078 6.75635 7.57578 7.6751 7.87578 8.6251C8.48203 10.5563 10.7008 11.4188 12.4695 10.4251C12.4945 10.4126 12.5258 10.4001 12.5758 10.3813C12.557 10.5188 12.5445 10.6313 12.5258 10.7438C12.3633 11.6938 11.9633 12.5313 11.3133 13.2438C10.6633 13.9626 9.86953 14.4563 8.93203 14.6938C8.60703 14.7751 8.27578 14.8126 7.94453 14.8688V14.8751Z",
    fill: "#0F62FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 3.44375C10.9316 3.4875 10.9629 3.525 10.9816 3.55625C11.6129 4.4875 12.2441 5.425 12.8691 6.35625C13.8379 7.79375 12.9316 9.7875 11.2129 10.0063C9.8816 10.1813 8.6691 9.23125 8.53785 7.90625C8.4816 7.3625 8.58785 6.85 8.8941 6.39375C9.5441 5.41875 10.2004 4.45 10.8566 3.48125C10.8629 3.46875 10.8754 3.4625 10.8941 3.4375L10.9004 3.44375Z",
    fill: "#0F62FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.df7de3faffb34e5184958672a5d08ea6.svg";
export { ForwardRef as ReactComponent };